import { type DriveFile } from '@/shared/DriveTypes';
import { Avatar, AvatarGroup } from '@mui/material';
import { hidden } from '~/app.css';
import { cx, getTextFromHTML, readingTime, resizePhoto, toLastModifiedTime, toTitleCase } from '~/utils/utils';
import * as styles from './LastModified.css';

const profileSize = 36 * window.devicePixelRatio;

export const LastModified = ({ content, file }: { content?: string | undefined; file: DriveFile }) => {
  const owner = file.owners?.[0];
  const lastModifyingUser = file.lastModifyingUser;
  const text = content ? getTextFromHTML(content) : '';
  const showLastUpdated = lastModifyingUser && lastModifyingUser.displayName !== owner?.displayName;

  return (
    <div className={styles.container}>
      <AvatarGroup className={styles.avatarGroup}>
        {owner && (
          <Avatar
            className={styles.createdAvatar}
            slotProps={{
              img: {
                referrerPolicy: 'no-referrer',
              },
            }}
            alt={owner.displayName}
            src={resizePhoto(owner.photoLink, profileSize)}
          >
            {owner.displayName[0]}
          </Avatar>
        )}
        {lastModifyingUser && owner?.photoLink !== lastModifyingUser.photoLink && (
          <Avatar
            className={styles.lastModifiedAvatar}
            slotProps={{
              img: {
                referrerPolicy: 'no-referrer',
              },
            }}
            alt={lastModifyingUser.displayName}
            src={resizePhoto(lastModifyingUser.photoLink, profileSize)}
          >
            {lastModifyingUser.displayName[0]}
          </Avatar>
        )}
      </AvatarGroup>

      <div className={styles.textContainer}>
        {owner && <div>Created by {toTitleCase(owner.displayName)}</div>}
        <div>
          Last updated: {toLastModifiedTime(file.modifiedTime)}
          {showLastUpdated && ` by ${toTitleCase(lastModifyingUser.displayName)}`}
          {text.length > 0 ? <span> • {readingTime(text)}</span> : ''}
        </div>
      </div>
    </div>
  );
};

export const EmptyLastModified = () => (
  <div className={cx(styles.container, hidden)}>
    <AvatarGroup className={styles.avatarGroup}>
      <Avatar className={styles.createdAvatar} alt="a">
        a
      </Avatar>
    </AvatarGroup>
  </div>
);
